export const envMode = process.env.NODE_ENV;
export const isDevEnv = envMode === 'development' ? true : false;
export const TRACKING_ID = 'G-C53BVHER8T';
export function postForm(path, params, method) {
  method = method || 'post';

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    if (key in params) {
      var hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
}

export function getPolicyType(value) {
  switch (value) {
    case 1:
      return 'Comprehensive';
    case 2:
      return 'Third Party';
    default:
      break;
  }
}
